import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { IModelInfo } from "../../entities/nu-model-info";

export interface ICreateModelNodeModel {
    modelId: string;
    nodeName: string;
    numTimePoints: number;
    numSubTimes: number;
    numStates: number;
    startTimePoint: number;

}

@Component
export default class CreateModelNodeDialog extends Vue {

    @Prop()
    value: ICreateModelNodeModel;


    onOkClick() {
        this.$emit("dialogAccepted", this.value);
    }

    onCancelClick() {
        this.$emit("dialogCanceled");
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/create-model-node-dialog/create-model-node-dialog.ts